import Axios, { AxiosError, AxiosInstance } from 'axios';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';
import Store from '../store';
import { auth0LoginRedirect } from '@Common/utils';
import { getAuthToken } from './utils/auth';

export default class Service {
  protected readonly axios: AxiosInstance;
  skipLogout = false;

  constructor(serviceUrl: string) {
    this.axios = Axios.create({
      baseURL: serviceUrl,
    });
    this.axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          LocalAuth.clearStorage();
          await auth0LoginRedirect();
          return Promise.reject(error);
        }
        return Promise.reject(error);
      },
    );
    this.axios.interceptors.request.use(
      async (config) => {
        const adminShellState = Store.getState().adminShell;
        const getAccessToken = adminShellState?.getAccessToken;
        const token = await getAuthToken(getAccessToken);
        if (token && config.headers) {
          (config.headers as { Authorization: string }).Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
    );
  }
}
